module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qskel2-9055934ec0eb7107031273b76df45d0b.jpg";